import { render } from "./ProjectTaskList.vue?vue&type=template&id=78e57e1b"
import script from "./ProjectTaskList.vue?vue&type=script&lang=js"
export * from "./ProjectTaskList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__